import { ABOUT } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

const IMG = "/hero-book-shoot.webp";

const TOC = [
  ["01", "The Record"],
  ["02", "The Work"],
  ["03", "Recognition"],
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
    >
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-12">
        {/* Ledger index */}
        <div className="lg:col-span-3">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#9c7a33]">
                [ Biography — File 01 ]
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <div className="mt-8 border-t border-[var(--line)]">
                {TOC.map(([n, label]) => (
                  <div
                    key={n}
                    className="flex items-baseline justify-between border-b border-[var(--line)] py-4"
                  >
                    <span className="font-mono text-xs text-[#9c7a33]">{n}</span>
                    <span className="text-sm uppercase tracking-[0.14em] text-[#1c2b4a]">
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-8 font-mono text-[10px] uppercase leading-loose tracking-[0.18em] text-[#5c6474]">
                Pasadena, CA —<br />
                Women's health, justice,
                <br />
                engineering &amp; story
              </p>
            </Reveal>
          </div>
        </div>

        {/* Editorial statement */}
        <div className="lg:col-span-6 lg:border-l lg:border-[var(--line)] lg:pl-12">
          <Reveal>
            <Eyebrow testid="about-eyebrow">{ABOUT.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-7 font-display text-4xl font-light leading-[1.05] tracking-tight text-[#1c2b4a] md:text-5xl">
              {ABOUT.heading}
            </h2>
          </Reveal>
          <div className="mt-9 space-y-6">
            {ABOUT.body.map((p, i) => (
              <Reveal key={i} delay={0.14 + i * 0.07}>
                <p className="text-base leading-relaxed text-[#5c6474] md:text-lg">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <blockquote className="mt-10 border-l-2 border-[#9c7a33] pl-6">
              <p className="font-display text-2xl italic leading-snug text-[#1c2b4a]">
                “Believe women before you treat them.”
              </p>
            </blockquote>
          </Reveal>

          {/* The record — ledger rows */}
          <Reveal delay={0.24}>
            <div className="mt-12 border-t border-[var(--line)]">
              {ABOUT.stats.map((s, i) => (
                <div
                  key={s.label}
                  className="group flex items-baseline justify-between gap-6 border-b border-[var(--line)] py-5"
                  data-testid={`about-stat-${i}`}
                >
                  <span className="font-mono text-2xl text-[#9c7a33] md:text-3xl">
                    {s.value}
                  </span>
                  <span className="text-right text-xs uppercase tracking-[0.16em] text-[#5c6474] transition-colors duration-300 group-hover:text-[#1c2b4a]">
                    {s.label}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        {/* Portrait + recognition */}
        <div className="lg:col-span-3">
          <Reveal delay={0.2}>
            <div className="relative">
              <div className="absolute -right-3 -top-3 hidden h-full w-full rounded-sm border border-[#9c7a33]/45 lg:block" />
              <div className="relative overflow-hidden rounded-sm border border-[var(--line)] bg-white p-2 shadow-[0_30px_60px_-30px_rgba(15,23,42,0.35)]">
                <img
                  src={IMG}
                  alt="Adonica Shaw portrait"
                  className="h-[400px] w-full rounded-sm object-cover object-[center_18%]"
                />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="mt-10">
              <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#9c7a33]">
                Recognition
              </p>
              <div className="mt-5 border-t border-[var(--line)]">
                {ABOUT.accolades.map((a, i) => (
                  <div
                    key={a}
                    className="flex items-baseline gap-4 border-b border-[var(--line)] py-4"
                  >
                    <span className="font-mono text-[10px] text-[#9c7a33]">
                      A-{String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-sm leading-snug text-[#1c2b4a]">{a}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
